

export function Favorites() {
    return (
        <>
            <h1>This is favorites</h1>
        </>
    )
}